import { z } from 'zod';

// An encrypted JWT (JWE) has five base64url encoded parts: header, encrypted key, IV, ciphertext and tag
const ENCRYPTED_JWT_PARTS = 5;
const base64url = z.base64url();

const isBase64url = (part: string) => base64url.safeParse(part).success;

const isEncryptedJwt = (token: string) => {
  const parts = token.split('.');
  return parts.length === ENCRYPTED_JWT_PARTS && parts.every(isBase64url);
};

// The partner token is a signed JWT, which some partners also encrypt (JWE)
const partnerToken = z.union([
  z.string().jwt(),
  z.string().refine(isEncryptedJwt),
]);

export const tokenRequestSearch = z.object({
  token: partnerToken,
});

const tokenRequest = z.object({
  token: partnerToken,
  idToken: z.string().jwt(),
  nonce: z.string(),
});

export default tokenRequest;

export type TokenRequest = z.infer<typeof tokenRequest>;
